/*!

 =========================================================
 * Ighe3 admin panel - v1.0.0
 =========================================================

 */
import Vue from "vue";
import App from "./App";
import router from "./router/index";
import store from "./store"
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import '@fortawesome/fontawesome-free/css/all.min.css'
import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(PaperDashboard);


import Framevuerk from 'framevuerk/dist/framevuerk.js'
import 'framevuerk/dist/framevuerk.css'

Vue.use(Framevuerk)
// Initializing App

import VueCookies from 'vue-cookies'
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueCookies)

// import VueSweetalert2 from 'vue-sweetalert2';
// Vue.use(VueSweetalert2)

import useFull from "./plugins/usefull";

Vue.use(useFull)
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);
/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");

